import {
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_DESCRIPTION,
  QUESTION_NPS,
  QUESTION_RATING,
  QUESTION_RANKING,
  QUESTION_OPEN_ENDED,
  QUESTION_NUMERIC_OPEN_ENDED,
  QUESTION_SLIDER,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
} from 'data/nodeTypes';

export const QUESTION_ICON_MAP = {
  [QUESTION_SINGLE]: 'single',
  [QUESTION_MULTIPLE]: 'double-tick',
  [QUESTION_OPEN_ENDED]: 'open-ended',
  [QUESTION_DESCRIPTION]: 'description-horizontal',
  [QUESTION_NUMERIC_OPEN_ENDED]: 'open-ended-numeric',
  [QUESTION_RATING]: 'star_negative',
  [QUESTION_RANKING]: 'ranking',
  [QUESTION_SLIDER]: 'slider',
  [QUESTION_NPS]: 'nps',
  [QUESTION_MATRIX_SINGLE]: 'matrix-single',
  [QUESTION_MATRIX_MULTIPLE]: 'matrix-multiple',
};
